import { createSelector } from "reselect";
import { RootState } from "../store";
import { CartState } from "./cart.reducer";
import { sanitizeScheduledTime } from "../../utils/utils.common";

const selectCartReducer = (state: RootState): CartState => state.cart;
export const selectCartItems = createSelector(
  [selectCartReducer],
  (cart) => cart.cartItems
);

export const selectCartKitchenId = createSelector(
  [selectCartReducer],
  (cart) => cart.kitchenId
);

export const selectOrderNote = createSelector(
  [selectCartReducer],
  (cart) => cart.orderNote
);

export const selectCustomerDetails = createSelector(
  [selectCartReducer],
  (cart) => cart.customerDetails
);

export const selectRawScheduledTime = createSelector(
  [selectCartReducer],
  (cart) => cart.scheduledTime
);

export const selectScheduledTime = createSelector(
  [selectRawScheduledTime],
  (scheduledTime) => sanitizeScheduledTime(scheduledTime)
);


export const selectCartCount = createSelector([selectCartItems], (cartItems) =>
  cartItems.reduce((total, cartItem) => {
    if (cartItem?.bundleParentId) return total;
    return total + cartItem.quantity;
  }, 0)
);

export const selectDiscount = createSelector(
  [selectCartReducer],
  (cart) => cart.discount
);

export const selectNewCustomer = createSelector(
  [selectCartReducer],
  (cart) => cart.customer
);

export const selectCustomerAccountCache = createSelector(
  [selectCartReducer],
  (cart) => cart.customerAccountCache
);

export const selectCartTotal = createSelector(
  [selectCartItems, selectDiscount],
  (cartItems, discount) => {
    const subtotal = cartItems.reduce(
      (total, cartItem) =>
        total + cartItem.quantity * cartItem.dishPriceWithVariants,
      0
    );

    if (!discount || !discount.type || !discount.value) {
      return subtotal;
    }

    if (discount.type === "percentage") {
      return subtotal - (subtotal * discount.value) / 100;
    }

    if (discount.type === "amount") {
      return subtotal - discount.value;
    }

    return subtotal;
  }
);

export const selectIsPaymentProcessing = createSelector(
  [selectCartReducer],
  (cart) => cart.isPaymentProcessing
);

export const selectDeliveryAddress = createSelector(
  [selectCartReducer],
  (cart) => cart.deliveryAddress
);

export const selectCartNotDiscountTotal = createSelector(
  [selectCartItems],
  (cartItems) =>
    cartItems.reduce(
      (total, cartItem) =>
        total + cartItem.quantity * cartItem.dishPriceWithVariants,
      0
    )
);
